import React from 'react';
import {TermsandCondition } from './container';

export const TermsandConditionScreen= ({ navigation }: { navigation: any }) => {
    return <TermsandCondition />
}